<template>
  <div class="login-container">
    <div class="title">{{ scenes[scene].title }}</div>
    <ValidationObserver ref="form">
        <ValidationProvider rules="required|numeric|length:11" v-slot="{ errors }" >
            <div class="input-item no-top">
                <span class="label">+86 ></span>
                <input type="text" v-model="data.phone" placeholder="请输入手机号">
            </div>
            <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider rules="required|numeric|length:4" v-slot="{ errors }" >
            <div class="input-item">
                <span class="label">验证码</span>
                <input type="text" v-model="data.code" placeholder="请输入短信验证码">
                <span v-if="sendCodeTime <= 0" class="phone-code" @click="sendPhoneCode">发送验证码</span>
                <span v-else class="phone-code">{{ sendCodeTime }}s</span>
            </div>
            <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>
    </ValidationObserver>
    <div class="remarks">{{ scenes[scene].remarks }}</div>
    <div class="login-button"><button class="clickAble" @click="login">{{ scenes[scene].button }}</button></div>
    <div class="cancel" @click="cancel">{{ scenes[scene].cancel }}</div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import { ValidationObserver, ValidationProvider, extend, setInteractionMode, validate } from 'vee-validate'
import { required, length, numeric } from 'vee-validate/dist/rules'
import { mlogin, bind, sendCode } from '@/api/user'
// 设置懒加载
setInteractionMode('lazy')
// 注册表单验证规则
extend('required', {
  ...required,
  message: '*此项必填*'
})
extend('length', {
  ...length,
  message: '*长度错误*'
})
extend('numeric', {
  ...numeric,
  message: '*输入数字*'
})
export default {
  name: 'Index',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
        sendCodeTime: 0,
        data: {
            phone: '',
            code: ''
        },
        scene: 'login',
        scenes: {
            login: {
                title: '欢迎来到子腾学堂',
                remarks: '未注册的手机号验证后自动创建账户',
                button: '登录',
                cancel: '跳过登录'
            },
            bind: {
                title: '绑定手机号',
                remarks: '请绑定手机号以完成操作',
                button: '绑定',
                cancel: '放弃绑定'
            }
        },
        redirect: ''
    }
  },
  created() {
    var query = this.$route.query
    if(query.hasOwnProperty('scene')){
      this.scene = query.scene == 'login'?'login':'bind'
    }
    if(query.hasOwnProperty('redirect')){
      this.redirect = query.redirect
    }
    this.id = query.id
  },
  methods: {
    login() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        var data = Object.assign(this.data, {type: this.scene});
        if(this.scene == 'bind'){
          bind(data).then(response=>{
            // 绑定成功
            this.$store.commit('LOGININFO', true)
            this.$store.commit('SET_ROLE', 'member')
            if(this.redirect) {
              this.$router.push({path: this.redirect, replace: true})
            }else{
              this.$router.push({path: '/', replace: true})
            }
          })
        } else {
          mlogin(data).then(response=>{
            // 登录成功
            this.$store.commit('LOGININFO', true)
            this.$store.commit('SET_ROLE', 'member')
            if(this.redirect) {
              this.$router.push({path: this.redirect, replace: true})
            }else{
              this.$router.push({path: '/', replace: true})
            }
          })
        }
        
      })
    },
    sendPhoneCode() {
      validate(this.data.phone, 'required|numeric|length:11').then(result => {
        if(!result.valid){
          return Toast({
            message: '请输入正确的手机号',
            position: 'bottom',
            duration: 1000
          })
        }
        sendCode({type: this.scene, phone: this.data.phone}).then(response => {
          this.startRefreshCodeTime()
        })
      })
    },
    cancel(){
      this.$store.commit('SET_ROLE', 'visitor')
      if(this.redirect) {
        this.$router.replace({path: this.redirect})
      }else{
        this.$router.replace({path: '/'})
      }
    },
    startRefreshCodeTime(){
      this.sendCodeTime = 60
      if (this.timer) {
        clearInterval(this.timer)
      } 
      this.timer = setInterval(() => {
        if (this.sendCodeTime <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
        this.sendCodeTime --
      }, 1000)
    },
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.login-container{
    max-width: 500px;
    margin: 0 auto;
    padding: 0 40px;
    text-align: left;
    .title{
        font-family:NotoSansHans-Regular,NotoSansHans;
        font-weight:400;
        color:rgba(68,68,68,1);
        padding: 60px 0;
        font-size: 28px;
    }
    .input-item{
        display: flex;
        align-items: center;
        font-size: 16px;
        padding: 10px 0;
        border-bottom: 1px #979797 solid;
        margin-top: 18px;
        &.no-top{
            margin-top: 0;
        }
        .label{
            font-size: 14px;
            width: 64px;
            flex: 0 0 64px;
        }
        input{
            flex:1;
            background:none;  
            outline:none;
            border:none;
            font-size: 16px;
            min-width: 19px;
            &:focus{
                border:none;
            }
        }
        .phone-code{
            color: #0085FF;
            flex: 0 0 80px;
            text-align: center;
        }
    }
    .remarks{
        font-size: 12px;
        font-family:NotoSansHans-Regular,NotoSansHans;
        color:rgba(153,153,153,1);
        padding: 30px 0;
    }
    .login-button{
        button{
            width: 100%;
            border: none;
            outline:none;
            background:rgba(202,222,255,1);
            border-radius: 8px;
            color: #152F5B;
            font-size: 18px;
            padding: 14px 0;
            &.clickAble{
                background:rgba(0,133,255,1);
                color: #fff;
            }
        }
    }
    .cancel{
        margin-top: 32px;
        color:rgba(153,153,153,1);
        font-size: 16px;
        text-align: center;
    }
    .error{
        color: red;
        font-size: 12px;
    }
}
</style>
